import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import StarIcon from "@mui/icons-material/Star";
import { getApi } from "../../hooks/Api";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";

function Review() {
  const [feedback, setFeedback] = useState([]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const fetch = async () => {
    const response = await getApi("feedback/get", { approved: true });
    setFeedback(response.data);
  };

  useEffect(() => {
    fetch();
  }, []);

  const fallbackReviews = [
    {
      patient: { firstname: "Sonu Vishwakarma" },
      rating: 5,
      comment:
        "I am from Indore and my family shifted in Bhopal from 12 months back. My wife was facing depression, anxiety, anger, and disturbed sleep. Dr Anoop treated her successfully and now she feels very happy and confident.",
    },
    {
      patient: { firstname: "Kanchan Shukla" },
      rating: 5,
      comment:
        "Very happy with treatment for fibroid and endometriosis. After taking homeopathic treatment for 6 months, pain and heavy bleeding almost stopped.",
    },
    {
      patient: { firstname: "Sadiq Ali" },
      rating: 5,
      comment:
        "Consulted for skin problems and got 60% relief within 30 days. Very effective medicine. He’s a good counselor and very helpful.",
    },
    {
      patient: { firstname: "Ali Muttaqui" },
      rating: 4,
      comment:
        "Dr Anoop's professional and detailed approach really helped. One of the best homeopaths in Bhopal.",
    },
    {
      patient: { firstname: "Shruti Srivastava" },
      rating: 4,
      comment:
        "Dr Anoop accurately diagnosed my daughter’s skin issue and helped cure my anxiety and IBS. Very reliable and knowledgeable.",
    },
  ];

  const allReviews = [...feedback, ...fallbackReviews].slice(0, 10);

  return (
    <section className="py-20 bg-neutral-900 relative" id="testimonials">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-gray-300 text-2xl font-semibold  font-poppins">
            What our Patient Say About our Medical
          </p>
        </div>

        <div className="relative">
          {/* Navigation Buttons */}
          <button
            ref={prevRef}
            className="absolute flex justify-center items-center z-10 w-10 h-10 top-1/2 -left-20 transform -translate-y-1/2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full shadow-md"
          >
            <ArrowBackIosNew fontSize="small" />
          </button>

          <button
            ref={nextRef}
            className="absolute flex justify-center items-center z-10 w-10 h-10 top-1/2 -right-20 transform -translate-y-1/2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full shadow-md"
          >
            <ArrowForwardIos fontSize="small" />
          </button>

          <Swiper
            modules={[Navigation, Autoplay]}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            autoplay={{ delay: 5000 }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {allReviews.map((review, index) => (
              <SwiperSlide key={index}>
                <div className="bg-neutral-800 rounded-xl p-6 min-h-[250px] flex flex-col">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-xl font-bold font-poppins">
                        {review?.patient?.firstname?.[0] || "P"}
                      </span>
                    </div>
                    <div className="ml-4">
                      <h4 className="text-white font-semibold capitalize font-poppins">
                        {review?.patient?.firstname}
                      </h4>
                      <div className="flex mt-1">
                        {Array.from({ length: review.rating || 5 }).map(
                          (_, i) => (
                            <StarIcon
                              key={i}
                              fontSize="small"
                              className="text-yellow-400 mr-1"
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed font-poppins">
                    {review.comment}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Review;
